import type { Debug } from "@otto-ec/global-resources";
import type { TrackingData, TrackingEvents } from "../types/tracking";

import { Log } from "../constants/log";
import { eventQBus } from "@otto-ec/event-q-bus";
import { tlEmptyStateCount } from "./labels/EmptyStateCount";
import { tlEmptyStateTime } from "./labels/EmptyStateTime";
import { tlSuggestRenderTime } from "./labels/SuggestRenderTime";
import { tlInitialSearchBoxTime } from "./labels/InitialSearchBoxTime";
import { tlSuggestTime } from "./labels/SuggestTime";
import { tlSearchType } from "./labels/SearchType";
import { TRACKING_EVENT } from "../events/trackingEvents";
import { TL_HIGGINS } from "./labels/higginsLabel";
import { get } from "svelte/store";
import { submitHistory } from "../store/HistoryStore";
import { SqrlLogger } from "../util/SqrlLogger";
import { tlInteraction } from "./labels/Interaction";

export class Tracking<L extends Log.TRACKING> {
  private log: SqrlLogger<L> = new SqrlLogger<L>(Log.TRACKING as L);

  /**
 *
 */
  get events(): TrackingEvents {
    return eventQBus<TrackingEvents>();
  }

  /**
 *
 *
 */
  trackOnNextPageImpression(urlTrackingData?: TrackingData) {
    const mergedTrackingData: TrackingData = { ...urlTrackingData, ...this.trackingData };
    this.updateTrackingData(mergedTrackingData);
    this.events.emit(TRACKING_EVENT.ON_NEXT_PI, mergedTrackingData);
    this.log.debug("Track on next PI submitting " + JSON.stringify(mergedTrackingData));
  }

  /**
 *
 */
  trackSubmitEvent(trackingData?: TrackingData) {
    this.events.emit(TRACKING_EVENT.SUBMIT, { ...trackingData });
    this.log.debug("Track submitted " + JSON.stringify(trackingData));
  }

  /**
 *
 *
 */
  trackCreateEventContext(eventContext?: string) {
    this.events.emit(TRACKING_EVENT.CREATE_EVENT_CONTEXT, eventContext);
    this.log.debug("Tracking created event context " + eventContext);
  }

  /**
 *
 *
 *
 */
  trackAddToEvent(trackingData?: TrackingData, mergeId?: string) {
    this.events.emit(TRACKING_EVENT.ADD_TO_EVENT, trackingData, mergeId);
    this.log.debug("Tracking added to event " + JSON.stringify(trackingData));
  }

  /**
 *
 *
 *
 */
  private updateTrackingData(trackingData: TrackingData) {
    const filterExists = get(submitHistory.store).some((item) => item.tags && item.tags.length > 0);
    if (filterExists) {
      trackingData[TL_HIGGINS.SEARCH_HISTORY] = "filter";
    }
    return trackingData;
  }

  private get trackingData(): TrackingData {
    return {
      ...tlEmptyStateCount.data,
      ...tlEmptyStateTime.data,
      ...tlSuggestTime.data,
      ...tlSuggestRenderTime.data,
      ...tlInitialSearchBoxTime.data,
      ...tlSearchType.data,
      ...tlInteraction.data,
    };
  }
}

export const tracking = new Tracking();
